export default function ComicreaBrand({
  light=false,
  compact=false,
  studio=true,
  href,
}:{
  light?:boolean;
  compact?:boolean;
  studio?:boolean;
  href?:string;
}){
  const body=<>
    <span className="comicreaMark" aria-hidden="true"><span className="comicreaMarkPanel"/><span className="comicreaMarkDot"/></span>
    {!compact&&<span className="comicreaWordmark">Comicrea{studio&&<em>Studio</em>}</span>}
  </>;
  const className=`comicreaBrand ${light?'light':''} ${compact?'compact':''}`;
  return href?<a className={className} href={href}>{body}</a>:<div className={className}>{body}</div>;
}
